// src/App.jsx
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './styles.css';




/* ---------- Parcel-friendly static asset URLs ---------- */
const logo = (() => {
  try { return new URL('./assets/logo.png', import.meta.url).href; } catch { return '/images/logo.png'; }
})();
const illustration = (() => {
  try { return new URL('./assets/1.png', import.meta.url).href; } catch { return '/images/1.png'; }
})();

/* ---------- Read API base from environment (fallback to localhost) ---------- */
const API_BASE = (
  (typeof import.meta !== 'undefined' && import.meta.env && (import.meta.env.VITE_API_BASE || import.meta.env.API_BASE)) ||
  (typeof process !== 'undefined' && process.env && (process.env.VITE_API_BASE || process.env.API_BASE)) ||
  'https://prompt-api.edutalknews.in'
);

/* ---------- Static credentials ---------- */
const CREDENTIALS = { username: 'atmia', password: '22@Atmiaeducation' };
const AUTH_KEY = 'indraq_auth';
const MS_24H = 24 * 60 * 60 * 1000;

/* ---------- Sample student (expanded with new visa-relevant fields) ---------- */
/* NOTE: keep all keys here so inputs remain controlled */
const SAMPLE = {
  firstName: 'Harkaran', lastName: 'Singh', email: 'harkaran@indraq.com', phone: '7986151418',
  pincode: '140301', city: 'Rupnagar', district: 'Rupnagar', state: 'Punjab', country: 'India',
  tenthPercentage: '75', twelfthPercentage: '66', twelfthStream: 'Non-Medical',
  collegeCourseCompleted: 'BSC Hospitality and Hotel Administration', ugDegree: '', ugPercentage: '',
  certifications: 'Diploma in Food & Beverage Services (2020)',

  preferredCountry: 'Canada', preferredState: '', preferredCollege: '', preferredCourse: 'Computer Science',
  intake: 'Fall 2025', workExperience: '0',
  work_company: '', work_position: '', work_startDate: '', work_endDate: '', work_duties: '',

  ielts: '6.5', toefl: '', gpa: '', budget: '150000', scholarshipNeeded: 'Yes',
  housing: 'On-campus', visaHistory: 'No prior refusals', additionalNotes: '',

  bankBalanceLiquid: 'Below 10 Lakhs', bankBalanceFD: '10 - 20 Lakhs', familyTotalAssets: '10 - 20 Lakhs',
  fatherEmploymentStatus: 'Employed', motherEmploymentStatus: 'Retired',
  sponsorName: '', sponsorRelation: '', sponsorOccupation: ''
};

/* ---------- Spinner ---------- */
/* Spinner: flexible, supports size (px) and inline mode */
function Spinner({ size = 36, inline = false, thickness = 4 }) {
  const style = {
    width: size,
    height: size,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: thickness,
    borderColor: 'rgba(59,130,246,0.12)',
    borderTopColor: '#3b82f6',
    animation: 'spin .9s linear infinite',
    display: inline ? 'inline-block' : 'block',
    verticalAlign: 'middle'
  };
  const wrapperStyle = inline ? { display: 'inline-flex', alignItems: 'center' } : { display: 'flex', justifyContent: 'center' };

  return (
    <div style={wrapperStyle} className={inline ? 'spinner-inline-wrap' : 'spinner-wrap'}>
      <div className="spinner" style={style} />
      {/* Keyframes are already declared in your CSS but keep them for safety */}
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}


/* ---------- Utilities ---------- */
function tryParseJsonMaybeString(item) {
  if (typeof item !== 'string') return item;
  const trimmed = item.trim();
  try { return JSON.parse(trimmed); } catch {}
  try {
    const first = trimmed.indexOf('{'), last = trimmed.lastIndexOf('}');
    if (first !== -1 && last !== -1 && last > first) return JSON.parse(trimmed.slice(first, last + 1));
  } catch {}
  return item;
}
function prettyJSON(obj) {
  try { return JSON.stringify(obj, null, 2); } catch { return String(obj); }
}
function getPath(obj, path) {
  if (!obj) return undefined;
  const parts = path.split('.');
  let cur = obj;
  for (const p of parts) {
    if (cur === null || cur === undefined) return undefined;
    cur = p.match(/^\d+$/) ? cur[Number(p)] : cur[p];
  }
  return cur;
}
function extractModelText(obj) {
  if (!obj) return null;
  if (typeof obj === 'string') return obj;
  const paths = [
    'choices.0.message.content','choices.0.message','choices.0.text','choices.0.content',
    'result.output','result.response','response','output','data.0.text','message','content'
  ];
  for (const p of paths) {
    const val = getPath(obj, p);
    if (val !== undefined && val !== null) {
      if (typeof val === 'string') return val;
      if (typeof val === 'object') {
        if (typeof val.content === 'string') return val.content;
        if (typeof val.text === 'string') return val.text;
        if (val?.message?.content && typeof val.message.content === 'string') return val.message.content;
      }
    }
  }
  function findLongestString(o) {
    let best = '';
    if (typeof o === 'string') return o;
    if (typeof o === 'object' && o !== null) {
      for (const k of Object.keys(o)) {
        const v = findLongestString(o[k]);
        if (v && v.length > best.length) best = v;
      }
    }
    return best;
  }
  return findLongestString(obj) || null;
}

/* ---------- Collapsible viewer ---------- */
function ValueNode({ value, name, depth = 0 }) {
  const parsed = tryParseJsonMaybeString(value);
  if (parsed !== value) return <ObjectNode data={parsed} name={name} depth={depth} />;
  const type = Array.isArray(value) ? 'array' : typeof value;
  if (type === 'object' && value !== null) return <ObjectNode data={value} name={name} depth={depth} />;
  if (type === 'string') {
    const maxInline = 160;
    const displayText = value.length > maxInline ? `${value.slice(0, maxInline)}…` : value;
    return (
      <div className="value-row">
        {name !== undefined && <span className="value-name">{name}:</span>}
        <span className="value-string">{displayText}</span>
        {value.length > maxInline && (
          <details className="value-details">
            <summary>Show full text</summary>
            <pre className="value-pre">{value}</pre>
          </details>
        )}
      </div>
    );
  }
  if (type === 'number' || type === 'boolean' || value === null) {
    return <div className="value-row">{name !== undefined && <span className="value-name">{name}:</span>}<span className="value-primitive">{String(value)}</span></div>;
  }
  return <pre className="value-pre">{String(value)}</pre>;
}
function ObjectNode({ data, name, depth = 0 }) {
  const isArray = Array.isArray(data);
  const keys = isArray ? data.map((_, i) => i) : Object.keys(data || {});
  const label = name !== undefined ? `${name}: ` : '';
  const summaryText = isArray ? `Array(${data.length})` : `Object{${keys.length}}`;
  const openByDefault = depth < 1;
  return (
    <details open={openByDefault} className="object-node" style={{ paddingLeft: depth * 8 }}>
      <summary className="object-summary">{label}{summaryText}</summary>
      <div className="object-children">
        {keys.length === 0 && <div className="object-empty">— empty —</div>}
        {keys.map((k, idx) => (
          <div key={idx} style={{ marginBottom: 6 }}>
            <ValueNode value={isArray ? data[k] : data[k]} name={isArray ? `[${k}]` : k} depth={depth + 1} />
          </div>
        ))}
      </div>
    </details>
  );
}

/* ---------- ModelOutputViewer ---------- */
function ModelOutputViewer({ data }) {
  const modelText = extractModelText(data);
  const meta = data;
  const handleCopyModel = useCallback(() => { try { navigator.clipboard.writeText(modelText || ''); alert('Copied model text'); } catch { alert('Copy failed'); } }, [modelText]);
  const handleCopyMeta = useCallback(() => { try { navigator.clipboard.writeText(prettyJSON(meta)); alert('Copied JSON'); } catch { alert('Copy failed'); } }, [meta]);
  const handleDownloadMeta = useCallback(() => {
    const blob = new Blob([prettyJSON(meta)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'model-output.json'; a.click(); URL.revokeObjectURL(url);
  }, [meta]);

  return (
    <div className="model-output">
      <div className="model-controls">
        <button onClick={handleCopyModel} className="btn-ghost">Copy model text</button>
        <button onClick={handleCopyMeta} className="btn-ghost">Copy JSON</button>
        <button onClick={handleDownloadMeta} className="btn-ghost">Download JSON</button>
      </div>

      {modelText ? (
        <div className="model-reply">
          <h4>Model reply</h4>
          <pre className="model-pre">{modelText}</pre>
        </div>
      ) : (
        <div className="muted">No extracted model text found in response.</div>
      )}

      <div className="meta-block">
        <h4>Full response (metadata)</h4>
        <div className="meta-scroll"><ObjectNode data={meta} depth={0} /></div>
      </div>
    </div>
  );
}

/* ---------- Login screen component ---------- */
function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState(''), [password, setPassword] = useState(''), [err, setErr] = useState(null);
  function submit(e) {
    e.preventDefault(); setErr(null);
    if (username === CREDENTIALS.username && password === CREDENTIALS.password) {
      const expiresAt = Date.now() + MS_24H;
      localStorage.setItem(AUTH_KEY, JSON.stringify({ username, expiresAt }));
      onLogin({ username, expiresAt });
    } else setErr('Invalid username or password');
  }
  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-left">
          <img src={logo} alt="Logo" className="login-logo" />
          <h2 className="brand">Atmia Education</h2>
          <div className="tagline">Secure AI Prompt Builder</div>
          <img src={illustration} alt="Illustration" className="login-illus" />
        </div>
        <div className="login-right">
          <h2>Welcome Back</h2>
          <p className="muted">Enter your credentials to access the panel</p>
          <form onSubmit={submit}>
            <input className="control" placeholder="Enter your username" value={username} onChange={e => setUsername(e.target.value)} />
            <input className="control" placeholder="Enter your password" type="password" value={password} onChange={e => setPassword(e.target.value)} />
            {err && <div className="field-error">{err}</div>}
            <button className="btn-primary" type="submit">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
}

/* ---------- Main App ---------- */
export default function App() {
  const [isAuthed, setIsAuthed] = useState(false);
  const [authedUser, setAuthedUser] = useState(null);

  const [student, setStudent] = useState(SAMPLE);
  const [promptTemplate, setPromptTemplate] = useState(`Paste your system prompt here...`);
  const [resp, setResp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [debugRequest, setDebugRequest] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed?.expiresAt && parsed.expiresAt > Date.now()) { setIsAuthed(true); setAuthedUser(parsed.username || CREDENTIALS.username); }
      else localStorage.removeItem(AUTH_KEY);
    } catch { localStorage.removeItem(AUTH_KEY); }
  }, []);

  function onLogin({ username }) { setIsAuthed(true); setAuthedUser(username); }
  function doLogout() { localStorage.removeItem(AUTH_KEY); setIsAuthed(false); setAuthedUser(null); setStudent(SAMPLE); setResp(null); setError(null); setJobId(null); setDebugRequest(null); }

  if (!isAuthed) return <LoginScreen onLogin={onLogin} />;

  function update(k, v) { setStudent(prev => ({ ...prev, [k]: v })); }

  async function runPrompt() {
    setLoading(true); setError(null); setResp(null); setJobId(null); setDebugRequest(null);
    try {
      const outPayload = { student, promptTemplate };
      let enqueueRes;
      try {
        enqueueRes = await axios.post(`${API_BASE}/api/test-prompt-job`, outPayload, { timeout: 15000 });
      } catch (e) {
        setError({ message: 'Failed to enqueue job', detail: e?.response?.data || e?.message || String(e) });
        setLoading(false); return;
      }

      if (!enqueueRes?.data?.jobId) { setError({ message: 'No jobId returned from enqueue', detail: enqueueRes?.data || enqueueRes }); setLoading(false); return; }

      const jobIdLocal = enqueueRes.data.jobId; setJobId(jobIdLocal); setDebugRequest({ payload: outPayload, jobId: jobIdLocal });

      let attempts = 0; const maxAttempts = 400; let delay = 1200; const startTime = Date.now();
      while (attempts < maxAttempts) {
        attempts++;
        try {
          const pollRes = await axios.get(`${API_BASE}/api/job/${jobIdLocal}`, { timeout: 15000 });
          if (pollRes?.data?.job) {
            const lastResult = pollRes.data.job;
            setResp(prev => ({ ...(prev || {}), job: lastResult }));
            if (lastResult.status === 'done') { const final = lastResult.result || lastResult; setResp(final); setLoading(false); return; }
            if (lastResult.status === 'failed') { const normalized = typeof lastResult.error === 'string' ? { message: lastResult.error } : (lastResult.error || { message: 'Job failed' }); setError({ message: normalized.message || 'Job failed', detail: normalized }); setLoading(false); return; }
          }
        } catch (pollErr) { console.warn('[FRONT] poll error', pollErr?.message || pollErr); }
        await new Promise(r => setTimeout(r, delay));
        delay = Math.min(8000, Math.floor(delay * 1.12));
        const elapsed = Math.round((Date.now() - startTime) / 1000);
        setDebugRequest(dr => ({ ...(dr || {}), poll: { attempts, delay, elapsed } }));
      }
      setError({ message: 'Timeout waiting for job result' }); setLoading(false); return;
    } catch (err) {
      setError({ message: String(err?.response?.data || err?.message || err) }); setLoading(false);
    }
  }

  const pollInfo = debugRequest?.poll;
  const pollStatusText = pollInfo ? `Polling: ${pollInfo.attempts} attempts · delay ${pollInfo.delay}ms · ${pollInfo.elapsed}s elapsed` : '';

  return (
    <div className="app-shell">
      {/* Sticky top navbar */}
      <div className="topbar">
        <div className="topbar-inner">
          <div className="brand-left">
            <img src={logo} className="topbar-logo" alt="logo" />
          </div>
          <div className="brand-right">
            <button className="btn-ghost" onClick={() => setStudent(SAMPLE)}>Reset</button>
            <div className="signed">Signed in as <strong>{authedUser}</strong></div>
            <button className="btn-ghost" onClick={doLogout}>Logout</button>
          </div>
        </div>
      </div>

      <main className="main-card" style={{ marginTop: 84 }}>
        <header className="page-header">
          <h1>Student Form</h1>
        </header>

        <section className="form-grid">
          <div className="form-column">
            {/* ... form fields (same as you already had) ... */}
            <h3>Personal Details</h3>
            <div className="row">
              <label>First Name<input value={student.firstName} onChange={e => update('firstName', e.target.value)} /></label>
              <label>Last Name<input value={student.lastName} onChange={e => update('lastName', e.target.value)} /></label>
            </div>

            <div className="row">
              <label>Email<input value={student.email} onChange={e => update('email', e.target.value)} /></label>
              <label>Phone<input value={student.phone} onChange={e => update('phone', e.target.value)} /></label>
            </div>

            <div className="row">
              <label>Pincode<input value={student.pincode} onChange={e => update('pincode', e.target.value)} /></label>
              <label>City<input value={student.city} onChange={e => update('city', e.target.value)} /></label>
            </div>

            <div className="row">
              <label>District<input value={student.district} onChange={e => update('district', e.target.value)} /></label>
              <label>State<input value={student.state} onChange={e => update('state', e.target.value)} /></label>
            </div>

            <h3>Academic Background</h3>
            <div className="row">
              <label>10th Percentage<input value={student.tenthPercentage} onChange={e => update('tenthPercentage', e.target.value)} /></label>
              <label>12th Percentage<input value={student.twelfthPercentage} onChange={e => update('twelfthPercentage', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>12th Stream<input value={student.twelfthStream} onChange={e => update('twelfthStream', e.target.value)} /></label>
              <label>College Course Completed<input value={student.collegeCourseCompleted} onChange={e => update('collegeCourseCompleted', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>UG Degree<input value={student.ugDegree} onChange={e => update('ugDegree', e.target.value)} /></label>
              <label>UG Percentage<input value={student.ugPercentage} onChange={e => update('ugPercentage', e.target.value)} /></label>
            </div>
            <div className="row">
              <label style={{ width: '100%' }}>Certifications / Additional Qualifications
                <textarea rows={3} value={student.certifications} onChange={e => update('certifications', e.target.value)} />
              </label>
            </div>

            <h3>Work Experience (if any)</h3>
            <div className="row">
              <label>Years of Experience<input value={student.workExperience} onChange={e => update('workExperience', e.target.value)} /></label>
              <label>Company<input value={student.work_company} onChange={e => update('work_company', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Position / Title<input value={student.work_position} onChange={e => update('work_position', e.target.value)} /></label>
              <label>Start Date<input type="date" value={student.work_startDate} onChange={e => update('work_startDate', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>End Date<input type="date" value={student.work_endDate} onChange={e => update('work_endDate', e.target.value)} /></label>
              <label style={{ width: '100%' }}>Key responsibilities
                <textarea rows={3} value={student.work_duties} onChange={e => update('work_duties', e.target.value)} />
              </label>
            </div>

            <h3>Preferences & Scores</h3>
            <div className="row">
              <label>Preferred Country<input value={student.preferredCountry} onChange={e => update('preferredCountry', e.target.value)} /></label>
              <label>Preferred State<input value={student.preferredState} onChange={e => update('preferredState', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Preferred College<input value={student.preferredCollege} onChange={e => update('preferredCollege', e.target.value)} /></label>
              <label>Course<input value={student.preferredCourse} onChange={e => update('preferredCourse', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Intake<input value={student.intake} onChange={e => update('intake', e.target.value)} /></label>
              <label>IELTS Overall<input value={student.ielts} onChange={e => update('ielts', e.target.value)} /></label>
            </div>

            <h3>Family & Financials (visa relevant)</h3>
            <div className="row">
              <label>Bank Balance (Liquid)<input value={student.bankBalanceLiquid} onChange={e => update('bankBalanceLiquid', e.target.value)} /></label>
              <label>Bank Balance (FDs)<input value={student.bankBalanceFD} onChange={e => update('bankBalanceFD', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Total Family Assets<input value={student.familyTotalAssets} onChange={e => update('familyTotalAssets', e.target.value)} /></label>
              <label>Scholarship needed<input value={student.scholarshipNeeded} onChange={e => update('scholarshipNeeded', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Father's Employment Status<input value={student.fatherEmploymentStatus} onChange={e => update('fatherEmploymentStatus', e.target.value)} /></label>
              <label>Mother's Employment Status<input value={student.motherEmploymentStatus} onChange={e => update('motherEmploymentStatus', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Sponsor Name<input value={student.sponsorName} onChange={e => update('sponsorName', e.target.value)} /></label>
              <label>Sponsor Relation<input value={student.sponsorRelation} onChange={e => update('sponsorRelation', e.target.value)} /></label>
            </div>
            <div className="row">
              <label>Sponsor Occupation<input value={student.sponsorOccupation} onChange={e => update('sponsorOccupation', e.target.value)} /></label>
              <label style={{ width: '100%', marginLeft: 0 }}>Additional Notes<textarea rows={3} value={student.additionalNotes} onChange={e => update('additionalNotes', e.target.value)} /></label>
            </div>

            <h3>Prompt (system prompt)</h3>
            <textarea className="prompt-box" value={promptTemplate} onChange={e => setPromptTemplate(e.target.value)} />
            <div style={{ marginTop: 12 }}>
              <button className="btn-primary" onClick={runPrompt} disabled={loading}>{loading ? 'Running...' : 'Run Prompt'}</button>
            </div>
          </div>
        </section>
      </main>

      <aside className="sidebar">
        <div className="sidebar-card">
          <h3>Raw Model Output</h3>

          {loading && (
            <>
              <Spinner />
              {pollStatusText && <div className="poll-text">{pollStatusText}</div>}
              {jobId && <div className="job-id">Job: {jobId}</div>}
            </>
          )}

          {error && !loading && (
            <div className="error-box">
              {typeof error === 'string' ? error : (error.message || JSON.stringify(error, null, 2))}
              {error.detail && <pre className="error-detail">{typeof error.detail === 'string' ? error.detail : JSON.stringify(error.detail, null, 2)}</pre>}
            </div>
          )}

          {!loading && resp && <ModelOutputViewer data={resp} />}

          {!loading && !resp && !error && <div className="muted">No model output yet. Click "Run Prompt" to start.</div>}
        </div>
      </aside>
    </div>
  );
}
